import hideOrShowCheckoutFields from './woocommerce/hideOrShowCheckoutFields'

hideOrShowCheckoutFields()
